const dataPage = (data, gsap, mm, smoother, ScrollTrigger) => {
		
	const $container = $(data.next.container).find('main');
	const $advantage = $('.industry-block.advantage');
	const $bene = $('.benefit-wrap').not('.nudge');
	const $dataTypes = $('.data-type-item');
	const $video = $('.data-video');
	
	if ($video.length) {
		const $videoTransplant = $video.clone();

		$('body').prepend($videoTransplant);

		$videoTransplant.find('video').get(0).play();
	}
	
	//mm.add("(min-width: 62rem)", () => {

	//  let st = ScrollTrigger.create({
	//    trigger: $container,
	//    pin: ".data-video",
	//    start: "top 97px",
	//  });

	//}, '.page-data');
	
	//mm.add("(min-width: 41rem)", () => {
		
	//  if ($bene.length) {
	//    smoother.effects($bene, {speed: 1.1});
	//  }
		
	//}, '.page-data');
	
	//mm.add("(max-width: 61rem)", () => {

	//  let st = ScrollTrigger.create({
	//    trigger: $container,
	//    pin: ".data-video",
	//    start: "top 86px",
	//    anticipatePin: 1,
	//    invalidateOnRefresh: true,
	//    immediateRender: false,
	//  });

	//}, '.page-data');
	
	/***************************************************************
		STATS ANIMATION
	***************************************************************/
 
	const $statTexts = $('.stat .h2');

	if ($statTexts) {

		$statTexts.each(function() {

			const $this = $(this);
			const $text = $this.text();
			const $trigger = $this.parents().eq(2);

			gsap.to($this, {
				scrambleText: {
					text: $text,
					chars: "#$@",
					revealDelay:1,
					tweenLength:false,
				}
			})

			gsap.to($this, {
				scrollTrigger: {
					trigger: $trigger,
					start: "top center",
				},
				scrambleText:{
					text: $text, 
					chars:"#$@", 
					speed:0.4
				},
				onStart: function() {
					$this.addClass('tweening');
				},
				onComplete: function() {
					$this.removeClass('tweening');
				}
			});

		});

	}
	
}

export {
	dataPage
};
